/**
 * Created by toomasp on 11.08.2015.
 */
"use strict"
import template from './address-autocomplete.html';

export default ["service", "translator", "config", (service, trl, config) => {
    function getDefault() {
        return {
            label: trl.translate('address-not-found'),
            value: '0'
        };
    }

    class AddressAutoCompleteDirective {
        restrict = 'A';
        replace = true;
        scope = {
            address: '=ngModel',
            target: '@',
            label: '@',
            required: '='
        };
        require = 'ngModel';
        template = template;

        link(scope, element) {
            scope.trl = trl.translate.bind(trl);


            //element = $(element);
            element.find('input:text')
                .autocomplete({
                    position: {
                        my: "left top+10",
                        at: "left bottom",
                        collision: "none"
                    },
                    source: [],
                    response: function (event, ui) {
                        scope.address.padreId = '';
                        scope.$apply();
                        if (scope.address.padreFullName.length < 2) {
                            return;
                        }
                        service.apiPostSync('address/normalize-address', {
                            value: scope.address.padreFullName
                        }, (data) => {
                            angular.forEach(data, (value) => {
                                ui.content.push({
                                    label: value.aadress,
                                    value: value.aadress,
                                    object: value
                                });
                            });
                        }, () => {
                            //noop
                        });
                        // Opening of manual address insert
                        // ui.content.push(getDefault());
                    },
                    select: function (event, ui) {
                        if (ui.item.value == "0") {
                            $("#" + $(this).attr("data-subtarget")).show().find(":input:visible:enabled:first").focus();
                            $(this).val("");
                            scope.address.showGazetter = true;
                            scope.address.padreFullName = '';
                            scope.address.padreId = '';
                            scope.$apply();
                            return false;
                        }
                        scope.address.padreFullName = ui.item.object.aadress;
                        scope.address.padreId = ui.item.object.rmaId || ui.item.object.aid;
                        scope.address.county = ui.item.object.maakondEhak;
                        scope.address.countyName = ui.item.object.maakond;
                        scope.address.municipality = ui.item.object.omavalitusEhak;
                        scope.address.municipalityName = ui.item.object.omavalitus;
                        scope.address.settlement = ui.item.object.omavalitusLiik === 'linn' ? ui.item.object.omavalitus : ui.item.object.asustusyksus;
                        scope.address.zipCode = ui.item.object.sihtnumber;
                        scope.address.street = ui.item.object.liikluspind + ' ' + ui.item.object.aadressinumber;
                        scope.$apply();
                    },
                    disabled: true
                });

            element.find('input:text').focus(function () {
                element.find('input:text').autocomplete('enable');
            });


            //.data("ui-autocomplete")
            //._renderMenu = function(ul, items)  {
            //    $.each(items, function(index, item) { this._renderItemData(ul, item)} )
            //}
        }
    }
    return new AddressAutoCompleteDirective();
}];



// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/address-autocomplete/address-autocomplete.directive.js